import * as React from "react"
import "./style_components.scss";

export default function ProductAccordionContentStyleComponents({infoBlock, itemIndex}) {
    return (
        <div className={`accordion-content-block style_components ${itemIndex % 2 === 0 ? 'is-even' : 'is-odd'}`}>

            <div className={`block-head`}>

                <img className={`head-icon`} src={infoBlock.presentation.image} alt=""/>

                <h4>{infoBlock.title}</h4>
                <h6>
                    <span>freight</span>
                    <img
                        src={`${infoBlock.transport ? `/static/images/icons/footprint/${infoBlock.transport}.png` :
                            '/static/images/product-passport/footprint.svg'}`}
                        alt=""/>
                </h6>

            </div>
            <div className={`product-item-info`}>
                {infoBlock.presentation.info.filter(item => item.key.toLowerCase() !== 'ethical audit').map(presentationItem => presentationItem.label && presentationItem.label.length > 0 ? (
                    <div className={`product-item-info-item`}>
                        <h5>{presentationItem.key}:</h5>
                        <h6>
                            {presentationItem.label}
                        </h6>
                    </div>
                ) : null)}

            </div>

        </div>
    )
}
